export default function Login() {
    return(
        <div style={{background: 'red'}}>
            Cogo log in
        </div>
    )
}